// You can customize the template with the help of this file
//baseURLs:'https://apis.paytok.com.ng'
//Template config options
const themeConfig = {
  app: {
    appName: 'Paytok',
    appLogoImage: require('@src/assets/images/logo/logo.png').default,
    headRoute: '',
    //baseURLs: 'https://apis.paytok.com.ng',
    //baseURLs: 'http://localhost:50001',
    baseURLs: 'http://23.254.225.116:50005',
    paymentURLs: {
      '': '',
      '/test': '',
      '/preLive': ''
    }
  },
  layout: {
    isRTL: false,
    skin: 'light', // light, dark, bordered, semi-dark
    type: 'vertical', // vertical, horizontal
    contentWidth: 'boxed', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: true
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true, // Enable scroll to top button
    toastPosition: 'top-right' // top-left, top-center, top-right, bottom-left, bottom-center, bottom-right
  }
}

export default themeConfig
